import { API } from "../API"
import { store } from "../redux/store";
import { notify } from "react-notify-toast"

class Auth {
  constructor() {
    this.authenticated = false
    this.admin = false
    this.error = null
    this.archived = false
    this.is_accept_contract = false
  }

  reset() {
    this.authenticated = false
    this.admin = false
    this.error = null
    this.archived = false
    this.is_accept_contract = false
  }

  // Log user in
  login(cb) {
    this.authenticated = true
  }

  // Log user out
  logout(cb) {
    let userType = window.localStorage.getItem('userType');
    let request_view_id = window.localStorage.getItem('request_view_id');
    window.localStorage.clear()
    window.localStorage.setItem('userType', userType);
    window.localStorage.setItem('request_view_id', request_view_id);
    window.localStorage.removeItem("googleDriveTokenExp")
    window.localStorage.removeItem("googleDriveToken")
    this.authenticated = false
    this.admin = false
  }

  verifyUserRole = () => {
    const { userID } = window.localStorage;
    const { user, college } = store.getState();
    if (userID) {
      if (user && user.user && user.user._id === userID) {
        if (user.user.role === 'admin') {
          this.admin = true;
          return 'admin';
        }
        return "teacher";
      } else if (college && college.user) {
        if (college.user.customer_id === userID) {
          return "customer";
        } else if (college.user.personnel_id === userID) {
          return "personnel";
        }
      }
    }

    return null;
  };

  // Check if user is Authenticated
  // passing in no userRole will return as valid for any role type
  async tokenCheck(userRole) {
    // this.reset()
    await API.tokenCheck()
      .then((response) => {
        const { token, admin, id, role } = response.data
        if (userRole) {
          if (role === userRole) {
            localStorage.setItem("token", token)
            localStorage.setItem("userID", id)
            if (admin) {
              this.admin = true
            }
            this.authenticated = true
          } else {
            switch (userRole) {
              case "teacher":
                this.error =
                  "You must be logged in as a Teacher to view this page."
                break
              case "customer":
                this.error =
                  "You must be logged in as a Manager to view this page."
                break
              case "personnel":
                this.error =
                  "You must be logged in as Personnel to view this page."
                break
            }
            this.authenticated = false
          }
        }
        else {
          this.authenticated = true
        }
      })
      .catch((error) => {
        if (error.response) {
          // this.error = "Please sign in to view this page."
        } else {
          console.dir(error)
          this.error = "Server Error. Please try again later."
        }
        this.authenticated = false
      })
    return {
      authenticated: this.authenticated,
      admin: this.admin,
      error: this.error,
      role: userRole,
    }
  }

  async authCheck(permission) {
    this.reset()
    const userRole = this.verifyUserRole();
    if (userRole === "customer" || userRole === "personnel") {
      await API.permissionCheck({ permission: permission })
        .then((response) => {
          const { token, id, role, permit, is_accept_contract } = response.data
          // console.log("response.data: ", response.data)
          if (permit > 0 || role === 'personnel') {
            localStorage.setItem("token", token)
            localStorage.setItem("userID", id)
            this.authenticated = true
            this.archived = !!response.data.archived
            this.is_accept_contract = is_accept_contract
          } else {
            this.authenticated = false
            this.error =
              "You must login as customer or personnel with adequate access permission to view this page"
          }
        })
        .catch((error) => {
          console.dir(error)
          if (error.response) {
            // this.error = "Please login to view this page."
          } else {
            this.error = "Server Error. Please try again later."
          }
          this.logout()
        })
    }
    else if(userRole === 'admin') {
      this.admin = true
    }
    else {
      this.authenticated = false;
      this.error = "You must login as customer or personnel to view this page"
      this.logout()
    }

    return {
      authenticated: this.authenticated,
      admin: this.admin,
      error: this.error,
      archived: this.archived,
      is_accept_contract: this.is_accept_contract
    }
  }
}

export default new Auth()
